<template>
  <div class="reminder-ribbon">
    <div class="reminder-ribbon-label">
      <span style="font-size: 10px !important;">CURRENT ACTIVE LOANS</span>
      <p class="text-center" style="font-size: 16px !important;height: 20px">{{ activeLoanCount }}</p>
    </div>
  </div>
</template>

<script>
import { DataType, Tool } from '@/util/index'
import { OriginationBusinessApi } from '@/api/pandaria'

const tool = new Tool()

export default {
  name: 'activity-reminder',
  props: {
    restricts: {
      type: Array,
      default: () => []
    },
    loan: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      defaultReminderType: null,
      activeLoanCount: 0
    }
  },
  computed: {
    prepareReminderData () {
      return this.restricts.length !== 0 && tool.isNotEmpty(this.loan) && tool.isNotEmpty(this.store.getters.getAccount)
    }
  },
  watch: {
    prepareReminderData: function (newVal) {
      if (newVal) {
        for (let i = 0; i < this.restricts.length; i++) {
          const currentLoanStatus = this.loan.loanStatus
          if (this.restricts[i].loanStatus === currentLoanStatus) {
            switch (currentLoanStatus) {
              case DataType.LoanStatus.AGENT_REVIEW.value: {
                this.defaultReminderType = DataType.WorkQueueType.AGENT_REVIEW.value
                break
              }
              case DataType.LoanStatus.CORRECTOR_REVIEW.value: {
                this.defaultReminderType = DataType.WorkQueueType.CORRECTOR_REVIEW.value
                break
              }
              case DataType.LoanStatus.UNDERWRITER_REVIEW.value: {
                this.defaultReminderType = DataType.WorkQueueType.UNDERWRITER_REVIEW.value
                break
              }
              case DataType.LoanStatus.TRIBE_REVIEW.value: {
                this.defaultReminderType = DataType.WorkQueueType.TRIBE_REVIEW.value
                break
              }
              case DataType.LoanStatus.POSITIVE_WITHDRAWN.value: {
                this.defaultReminderType = DataType.WorkQueueType.POSITIVE_WITHDRAWN.value
                break
              }
              case DataType.LoanStatus.NEGATIVE_WITHDRAWN.value: {
                this.defaultReminderType = DataType.WorkQueueType.NEGATIVE_WITHDRAWN.value
                break
              }
              default: break
            }
            this.getActualTribeReviewCount()
            return
          }
        }
      }
    }
  },
  mounted () {
    const timer = setInterval(() => this.getActualTribeReviewCount(), 1000 * 60)
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
    })
  },
  methods: {
    getActualTribeReviewCount () {
      const reminderType = this.defaultReminderType
      if (tool.isNotEmpty(reminderType)) {
        const _this = this
        const data = {
          portfolioIdList: this.store.getters.getAccount.portfolioIdList,
          reminderType: reminderType
        }
        OriginationBusinessApi.getReminderCount(data, function (data) {
          _this.activeLoanCount = data
        }, function () {
          _this.activeLoanCount = 0
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .reminder-ribbon {
    border-top-right-radius: 6px;
    display: block;
    position: relative;
    float: right;
    background-color: #03a9f4;
    color: white;
    opacity: 0.88;
    top: -6px;
    margin-right: 10px;
    .reminder-ribbon-label {
      right: 0;
      p {
        margin: 0;
      }
      span {
        position: relative;
        display: inline-block;
        text-align: center;
        background: #03a9f4;
        font-size: inherit;
        line-height: 1;
        padding: 8px 8px 0px;
        border-top-right-radius: 8px;
        width: 170px;
      }
      span:before {
        background: #03a9f4;
        height: 6px;
        width: 6px;
        left: -6px;
        top: 0;
      }
      span:after {
        background: #005da0;
        height: 6px;
        width: 8px;
        border-radius: 8px 8px 0 0;
        left: -8px;
        top: 0;
      }
      span:before, span:after {
        position: absolute;
        content: '';
        display: block;
      }
    }
    .reminder-ribbon-label:after {
      position: absolute;
      content: '';
      display: block;
      width: 0;
      height: 0;
      border-left: 85px solid transparent;
      border-right: 85px solid transparent;
      border-top: 10px solid #03a9f4;
    }
  }
</style>
